export const cookieSessionKey = 'gaishishukatsu';
